
import { Component, Mixins } from "vue-property-decorator";
import { default as StandardTextDrawableObjectDrawerBase } from "./StandardTextDrawableObjectDrawerBase.vue";

@Component
export default class SelectableObjectDrawerBase extends Mixins(StandardTextDrawableObjectDrawerBase) {
  // TODO: 必要な固有メンバ追加.
}
